import { initialize } from "@bloomreach/spa-sdk";
import { createConfiguration } from "../../configuration/configuration/configuration.js";
async function getBrPage(apiUrl, path, options) {
  return initialize(createConfiguration({ apiUrl, path, options }));
}
export {
  getBrPage
};
//# sourceMappingURL=get-page.js.map
